import type { CancelablePromise } from '/src/api';
import { OpenAPI, request as __request } from '/src/api';
import { ChargingNetworks } from '/src/lib/models/ChargingNetwork';

export type CreateChargingNetworkRequest = {
  name: string;
};

export class ChargingNetworkService {
  /**
   * List Charging Networks
   * @returns ChargingNetwork[]
   * @throws ApiError
   */
  public static listChargingNetworks(): CancelablePromise<ChargingNetworks[]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/chargingNetworks',
    });
  }

  /**
   * Create Charging Network
   * @returns ChargingNetwork
   * @throws ApiError
   */
  public static create(data: CreateChargingNetworkRequest): CancelablePromise<ChargingNetworks> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/chargingNetworks',
      body: data,
    });
  }
}
